export default __webpack_public_path__ + "bccfac37c6974b96347c7bad064fd203.svg";